import { atom } from 'nanostores'
import type { Product } from '@forest/native-services'

export const $annualEarlyBirdProduct = atom<undefined | Product>()

export function setAnnualEarlyBirdProduct(product: Product) {
  $annualEarlyBirdProduct.set(product)
}
